import type { ApiBaseResponse } from '@module/apis/type';
import convertFormData from '@module/utils/convertFormData';
import { fetchExtended } from '@module/utils/fetch/client-fetch';
import type {
  SubtitleApplyCheckResponse,
  SubtitleCreatorAuthResponse,
  SubtitlePluginPathResponse,
  SubtitleRequestCancelParams,
  SubtitleRequestHangulParams,
  SubtitleRequestHangulResponse,
  SubtitleRequestListResponse,
  SubtitleRequestParams,
  SubtitleStreamKeyResponse,
} from './type';

export const getSubtitleRequestList = async () => {
  const res = await fetchExtended(`/v1/caption/request_list`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as SubtitleRequestListResponse;
};

export const postSubtitleRequest = async (params: SubtitleRequestParams) => {
  const res = await fetchExtended(`/v1/caption/request`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const postSubtitleRequestCancel = async (params: SubtitleRequestCancelParams) => {
  const res = await fetchExtended(`/v1/caption/request_cancel`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const getSubtitleApplyCheck = async () => {
  const res = await fetchExtended(`/v1/caption/apply_check`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as SubtitleApplyCheckResponse;
};

export const getSubtitleCreatorAuth = async ({ idx }: { idx: number }) => {
  const res = await fetchExtended(`/v1/caption/creator_auth?captionRequestIdx=${idx}`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as SubtitleCreatorAuthResponse;
};

export const getSubtitlePluginPath = async ({ type }: { type: 'plugin' | 'guide' }) => {
  const res = await fetchExtended(`/v1/caption/plugin_path?type=${type}`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as SubtitlePluginPathResponse;
};

export const postSubtitleRequestHangul = async (params: SubtitleRequestHangulParams) => {
  const res = await fetchExtended(`/v1/caption/hangulize`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as SubtitleRequestHangulResponse;
};

export const getSubtitleStreamKey = async () => {
  const res = await fetchExtended(`/v1/caption/streamKey`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as SubtitleStreamKeyResponse;
};

export const postSubtitleRefreshStreamKey = async () => {
  const res = await fetchExtended(`/v1/caption/refresh_streamKey`, {
    method: 'POST',
    credentials: 'include',
  });

  const result = await res.json();

  return result as SubtitleStreamKeyResponse;
};
